export default __webpack_public_path__ + "static/media/404.337e0773.png";